/**
 * hasBadWords(text) -> boolean
 * Persian bad-word checker for a description field.
 * Self-contained: no imports needed.
 */

const BAD_WORDS: string[] = [
  // vulgar / sexual
  'کیر',
  'کیرخر',
  'کیرخور',
  'کص',
  'کصکش',
  'کصخل',
  'کصافت',
  'کصافط',
  'کث',
  'کوص',
  'کصلیس',
  'کصده',
  'قس',
  'کسکش',
  'کسخل',
  'کسشر',
  'کسننه',
  'کسمادر',
  'کون',
  'کونی',
  'کونده',
  'کونکش',
  'کونگشاد',
  'کوس',
  'مادرکونی',
  'خایهمال',
  'خایمال',
  'خایه',
  'گایید',
  'گاییدم',
  'گاییدن',
  'گاییدی',
  'بگایید',
  'بگاییدم',
  'کیرم',
  'نگاییدم',
  'گاییده',
  'گایدی',
  'گایدن',
  'بکنمت',
  'بکنت',
  'بکنش',
  'بمال',
  'مالوندن',
  'میخوریش',
  'رید',
  // prostitution / family insults
  'جنده',
  'جندهخونه',
  'جاکش',
  'کاسکش',
  'زنیکه',
  'جیندا',
  'زنکاسده',
  'مادرجنده',
  'ننهجنده',
  'مادرقحبه',
  'ننهقحبه',
  'قحبه',
  'فاحشه',
  'هرزه',
  'پدرسگ',
  'پدرسوخته',
  'حرومزاده',
  'حرامزاده',
  'حرومی',
  'ولدزنا',
  'ولدالزنا',
  'زنازاده',
  'کثافط',
  'خارکسده',
  'مادرسگ',
  'گورومساخ',
  'قرمساق',
  'غرمساق',
  'قرمصاق',
  'غرمصاق',
  'قورومساق',
  'ساکونی',
  'سیکتیر',
  'سیکیم',
  'سیکیمی',
  'گیخوار',
  'دول',
  'سرکیر',
  'نرکده',
  // scatological
  'گوه',
  'گهخور',
  'گوهخور',
  'عن',
  'گوز',
  'گوزو',
  'شاش',
  // insults
  'عوضی',
  'پفیوز',
  'پوفیوز',
  'لاشی',
  'بیشرف',
  'بیناموس',
  'بیغیرت',
  'دیوث',
  'دیوس',
  'دیوص',
  'کثافت',
  'اوسکول',
  'اسکول',
  'بیشعور',
  'لاشخور',
  'عنتر',
  'نفهم',
  'اسکل',
  'اسگل',
  'اسگول',
  'اوسکل',
  'اوسگل',
  'اوصکل',
  'اوصگل',
  'شاسگول',
  'قرتی',
  'دخترقرتی',
  'اوبی',
  'پستون',
  'گاگول',
  'لاکونی',
  'بپرروش',
  'عمتو',
  'منگل',
  'احمق',
  'دله',
  'ابله',
  'نکبت',
  'پلشت',
  'خرفت',
  'مرتیکه',
  'مردیکه',
  'ناموستو',
  'نزنمتا',
  'هیز',
  'پپه',
  'ملنگ',
  'مرضداری',
  // finglish
  'kir',
  'kiir',
  'kos',
  'koon',
  'kun',
  'kunde',
  'kundeh',
  'kuniii',
  'koskesh',
  'kosnane',
  'kosmadar',
  'koskhol',
  'jende',
  'gende',
  'jakesh',
  'madarjende',
  'madarghahbe',
  'ghahbe',
  'gayidam',
  'gaidam',
  'bgaidam',
  'haromzade',
  'haramzade',
  'pofiuz',
  'pofyuz',
  'lashi',
  'divus',
  'bishraf',
  'pedarsag',
  'dic',
  'sik',
  'anal',
  'ass',
];

const BAD_PHRASES: string[] = [
  'مادر جنده',
  'ننه جنده',
  'زن جنده',
  'مادر سگ',
  'پدر سگ',
  'سگ پدر',
  'مادر به خطا',
  'یبن زنا',
  'ابن یزید',
  'زنا زاده',
  'دهن سرویس',
  'دهنت سرویس',
  'فاک فیس',
  'خایه مال',
  'خایه خور',
  'کث لیس',
  'ممه خور',
  'سوراخ کون',
  'لا پا',
  'جلق زدن',
  'شق کردن',
  'بکن توش',
  'داگ استایل',
  'سکس چت',
  'فیلم سوپر',
  'سگ تو روحت',
  'سگ ناموس',
  'تخم سگ',
  'جنده پولی',
  'شل مغز',
  'گردن دراز',
  'گوش دراز',
  'توله سگ',
  'چس خور',
  'خفه شو',
  'خفه خون',
  'بی پدر',
  'بی ناموس',
  'بی غیرت',
  'بی عفت',
  'مرض داری',
  'پدر صلواتی',
  'سگ صفت',
  'سگ دهن',
  'دیوس خان',
  'عن تر',
];

// Suffixes so "کیری", "کونه", "جنده‌ها" are still caught.
const SUFFIXES = new Set([
  '',
  'ی',
  'ه',
  'م',
  'ت',
  'ش',
  'ها',
  'ای',
  'ان',
  'مون',
  'تون',
  'شون',
]);

const MIN_STEM_LENGTH_FOR_SUFFIX = 3;

function normalize(input: string): string {
  return input
    .normalize('NFKC')
    .replace(/[ً-ٰٟ]/g, '') // diacritics
    .replace(/ـ/g, '') // tatweel
    .replace(/[يى]/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/ة/g, 'ه')
    .replace(/[أإٱ]/g, 'ا')
    .replace(/ئ/g, 'ی')
    .replace(/ؤ/g, 'و')
    .replace(/[۰-۹]/g, d => String(d.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - 0x0660))
    .replace(/[​-‏‪-‮⁦-⁩﻿]/g, '')
    .toLowerCase()
    .replace(/([؀-ۿ])\1+/gu, '$1')
    .replace(/([a-z])\1{2,}/g, '$1$1')
    .replace(/\s+/g, ' ')
    .trim();
}

const badWordSet = new Set(BAD_WORDS.map(normalize));
const badPhraseList = BAD_PHRASES.map(normalize);

function isBadToken(token: string): boolean {
  if (!token) return false;
  if (badWordSet.has(token)) return true;
  let found = false;
  badWordSet.forEach(word => {
    if (
      !found &&
      Array.from(word).length >= MIN_STEM_LENGTH_FOR_SUFFIX &&
      token.startsWith(word) &&
      SUFFIXES.has(token.slice(word.length))
    ) {
      found = true;
    }
  });
  return found;
}

/** Splits into tokens and also joins runs of single letters ("ک ی ر"). */
function tokenize(normalized: string): string[] {
  const tokens = normalized.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  const result = [...tokens];

  let run: string[] = [];
  const flush = () => {
    if (run.length >= 2) result.push(run.join(''));
    run = [];
  };
  for (const token of tokens) {
    if (Array.from(token).length === 1 && /\p{L}/u.test(token)) run.push(token);
    else flush();
  }
  flush();

  return result;
}

/**
 * Returns true if the given description text contains a Persian (or
 * Finglish) bad word, false otherwise.
 */
export function hasBadWords(text: string): boolean {
  if (!text) return false;
  const normalized = normalize(text);

  if (badPhraseList.some(phrase => normalized.includes(phrase))) return true;
  if (tokenize(normalized).some(isBadToken)) return true;

  return false;
}
